import React from "react";
import PropTypes from "prop-types";

const AddressDisplay = ({address}) => {
  if (!address) return <span className="address-missing">N/A</span>;
  const {street, city, state, country, postalCode} = address;
  if (!street && !city && !state && !country && !postalCode) return <span className="address-missing">N/A</span>;
  return (
    <div className="address">
      {street && <div className="address-street">{street}</div>}
      {(city || state || postalCode) && <div className="address-region">
        {city}{(city && state && ', ')}{state}{(city || state) && postalCode && '  '}{postalCode}
      </div>}
      {country && <div className="address-country">{country}</div>}
    </div>
  );
};

AddressDisplay.propTypes = {
  address: PropTypes.object
};

export default AddressDisplay;


// WEBPACK FOOTER //
// ./src/common/AddressDisplay.js